<template>
  <div id="services-home">
    <wave-component color="primary"/>

    <div class="main-container">
      <h2 class="text-center service-title pb-5">Tecnologia e Inovação</h2>
      <v-row class="pb-10" align="center" justify="center">
        <v-col id="services-bar" cols="12">
          <v-row class="text-center white--text align-center justify-center main-container">
            <v-col class="d-flex justify-center" cols="4" :key="service.id" v-for="service in services1">
              <div :class="['btn-services', {active: carouselItem1 === service.id}]" @click="carouselItem1 = service.id"
                   :style="{backgroundColor: service.color}">
                {{ service.title }}
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-carousel v-model="carouselItem1" height="auto"
                  :show-arrows="false"
                  hide-delimiter-background
                  hide-delimiters
                  touchless
      >
        <v-carousel-item :key="service.id" v-for="service in services1" class="service-carousel-item">
          <service-card :services="service.items" :color="service.color"/>
        </v-carousel-item>
      </v-carousel>
    </div>

    <div class="main-container">
      <h2 class="text-center service-title pb-5">Energia e Prevenção</h2>
      <v-row class="pb-10" align="center" justify="center">
        <v-col id="services-bar" cols="12">
          <v-row class="text-center white--text align-center justify-center main-container">
            <v-col class="d-flex justify-center" cols="4" :key="service.id" v-for="service in services2">
              <div :class="['btn-services', {active: carouselItem2 === service.id}]" @click="carouselItem2 = service.id"
                   :style="{backgroundColor: service.color}">
                {{ service.title }}
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-carousel v-model="carouselItem2" height="auto"
                  :show-arrows="false"
                  hide-delimiter-background
                  hide-delimiters
                  touchless
      >
        <v-carousel-item :key="service.id" v-for="service in services2" class="service-carousel-item">
          <service-card :services="service.items" :color="service.color"/>
        </v-carousel-item>
      </v-carousel>
    </div>
  </div>
</template>

<script>
import WaveComponent from '@/components/WaveComponent.vue';
import ServiceCard from '@/views/home/ServiceCard.vue';

export default {
  name: 'ServicesHome',
  components: {ServiceCard, WaveComponent},
  data: () => ({
    carouselItem1: 0,
    carouselItem2: 0,
    services1: [
      {
        id: 0,
        title: 'TELECOM',
        color: '#fd6600',
        items: [
          {
            id: 1,
            title: 'Fibra óptica',
            icon: 'fibra.png',
            img: 'fibra_optica.jpg',
            services: [
              'Fusão de fibra óptica',
              'Certificação de rede óptica',
              'Montagem de caixas de emenda'
            ]
          },
          {
            id: 2,
            title: 'Elaboração de projetos',
            icon: 'fibra.png',
            img: 'elaboracao_projetos.jpg',
            services: [
              'Elaboração de projeto construtivo',
              'Elaboração de orçamentos de rede FTTx',
              'Elaboração de projetos de Compartilhamento de infraestrutura – Uso Mútuo'
            ]
          },
          {
            id: 3,
            title: 'Cabeamento e Infraestrutura',
            icon: 'fibra.png',
            img: 'cabeamento_infra.jpg',
            services: [
              'Cabeamento estruturado',
              'Execução de infraestrutura de redes subterrânea e aérea para rotas de cabos ópticos e metálicos',
              'Remanejamento de infraestrutura de rede aérea e subterrânea',
              'Montagem de infraestrutura para a instalação de Data Center: Construção de ambientes climatizados, sala de no breaks e geradores, sistema de combate a incêndio, cabeamento óptico, cabeamento de par metálico, cabeamento elétrico e ativos de infraestrutura de rede',
              'Conexões e Configuração de equipamentos'
            ]
          }
        ]
      },
      {
        id: 1,
        title: 'DEV',
        color: '#126095',
        items: [
          {
            id: 1,
            title: 'Desenvolvimento de Softwares',
            icon: 'dev.png',
            img: 'desenvolvimento_softwares.jpg',
            services: [
              'Desenvolvimento de Aplicativos',
              'Desenvolvimento de Sistemas',
              'Criação de Sites',
              'Integração de sistemas',
              'Análise de dados com IA'
            ]
          },
          {
            id: 2,
            title: 'Serviços de Nuvem',
            icon: 'dev.png',
            img: 'servicos_nuvem.jpg',
            services: [
              'Virtualização e gerenciamento de cloud computing',
              'Backup e recuperação de dados em nuvem',
              'Hospedagem de sites'
            ]
          },
          {
            id: 3,
            title: 'Gerenciamento de servidores',
            icon: 'dev.png',
            img: 'gerenciamento_servidores.jpg',
            services: [
              'Implantação e gestão de servidor de logs',
              'Implantação e gestão de servidor de e-mails'
            ]
          },
        ]
      },
      {
        id: 2,
        title: 'AUTOMAÇÃO',
        color: '#960000',
        items: [
          {
            id: 1,
            title: 'Hardware',
            icon: 'automacao.png',
            img: 'hardware.jpg',
            services: [
              'Proteção de carga e circuito',
              'Dispositivos de conexão',
              'Inversores',
              'Computadores e monitores industriais',
              'Produtos de controle industrial',
              'Módulos de entrada/saída',
              'Soluções integradas',
              'Painéis de controle',
              'Sensores e chaves',
              'Interface de sinal'
            ]
          },
          {
            id: 2,
            title: 'Controle',
            icon: 'automacao.png',
            img: 'controle.jpg',
            services: [
              'Controle de iluminação',
              'Controle de movimento',
              'Controle do motor'
            ]
          },
          {
            id: 3,
            title: 'Monitoramento',
            icon: 'automacao.png',
            img: 'monitoramento.jpg',
            services: [
              'Monitoramento da condição',
              'Monitoramento de energia',
              'Monitoramento de desempenho'
            ]
          },
          {
            id: 4,
            title: 'Tecnologia',
            icon: 'automacao.png',
            img: 'tecnologia.jpg',
            services: [
              'Projeto e montagem de quadro de automação',
              'Sistemas digitais de controle distribuído',
              'Interface de operação e programação (IHM)',
              'Tecnologia de carrinho independente',
              'Infraestrutura e segurança de rede',
              'Análise de dados'
            ]
          },
        ]
      }
    ],
    services2: [
      {
        id: 0,
        title: 'ELÉTRICA',
        color: '#d6d000',
        items: [
          {
            id: 1,
            title: 'Energia Solar',
            icon: 'eletrica.png',
            img: 'energia_solar.jpg',
            services: [
              'Elaboração de projetos fotovoltaicos',
              'Instalação de sistemas solares residenciais e industriais',
              'Monitoramento remoto de geração solar',
              'Consultoria em eficiência energética',
              'Vistoria técnica para viabilidade solar',
              'Regularização junto à concessionária',
              'Integração com sistemas de energia elétrica existentes',
              'Implantação de sistemas on-grid e off-grid',
              'Instalação de estruturas e suportes para painéis solares',
              'Treinamento e capacitação em energia solar',
            ]
          },
          {
            id: 2,
            title: 'Residencial e Comercial',
            icon: 'eletrica.png',
            img: 'eletrica_residencial.jpg',
            services: [
              'Projetos elétricos residenciais, comerciais e industriais',
              'Dimensionamento de circuitos elétricos',
              'Instalação de sistemas de iluminação e tomadas',
              'Montagem de quadros elétricos'
            ]
          }
        ]
      },
      {
        id: 1,
        title: 'SEG. DO TRAB.',
        color: '#42741b',
        items: [
          {
            id: 1,
            title: 'Laudos',
            icon: 'seguranca.png',
            img: 'laudo.jpg',
            services: [
              'LTCAT - laudo Técnico das Condições Ambientais de Trabalho',
              'LI - Laudo de Insalubridade - NR-15',
              'LP - Laudo de Periculosidade - NR-16',
              'RIT - Relatório das Instalações Elétricas - NR-10',
              'Laudo de para-raios / SPDA - NR-10',
              'PPP - Perfil Profissiográfico Previdenciário',
              'Avaliação de ruído externo',
              'Laudo de iluminamento',
              'ART - Análise de Risco da Tarefa'
            ]
          },
          {
            id: 2,
            title: 'Análises e Auditoria',
            icon: 'seguranca.png',
            img: 'auditoria.jpg',
            services: [
              'PGR - Programa de Gerenciamento de Riscos - NR-01',
              'APR - Análise Preliminar de Riscos',
              'AET - Análise Ergonômica do Trabalho - NR-17',
              'Mapa de Riscos Ambientais - NR-05',
              'Ordem de Serviço de Segurança do Trabalho - NR-01',
              'Auditoria de Segurança do Trabalho',
            ]
          }
        ]
      }
    ]
  })
}
</script>

<style scoped>
#services-bar {
  max-width: 1000px;
}

#services-home {
  background-color: #0d0c37;
  font-size: 25px;
}

.btn-services {
  width: 250px;
  padding: 5px 5px;
  border-radius: 22px;
  opacity: 0.3;
  cursor: pointer;
}

.btn-services.active {
  opacity: 1;
}

.service-title {
  color: #E7E6FF;
  letter-spacing: 2px;
  font-size: 40px;
  font-family: "Montserrat", sans-serif;
}

@media screen and (max-width: 1244px) {
  #services-bar {
    font-size: 10px;
    max-width: 800px;
  }

  .service-title {
    font-size: 25px;
  }

  .btn-services {
    width: 200px;
    font-size: 9px;
  }
}
</style>
